import { useState } from 'react';
import { ApiError, call } from '../api';

/** Telefoon als afstandsbediening — de kant van de telefoon. */

type Key = 'ArrowUp' | 'ArrowDown' | 'ArrowLeft' | 'ArrowRight' | 'Enter' | 'Escape' | 'home' | 'search' | 'info' | 'MediaPlayPause' | 'seek-back' | 'seek-forward' | 'ChannelUp' | 'ChannelDown';

export function RemotePage({ initial }: { initial: string }) {
  const [input, setInput] = useState(initial);
  const [code, setCode] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const connect = async (c: string) => {
    setError(null);
    try {
      await call(`/api/remote/${c}/cmd`, { method: 'POST', body: JSON.stringify({ hello: true }) });
      setCode(c);
    } catch (e) {
      setError(e instanceof ApiError && e.message !== e.code ? e.message : 'Geen scherm gevonden met deze code.');
    }
  };

  const press = (key: Key) => {
    if (!code) return;
    try {
      navigator.vibrate?.(12);
    } catch {
      // geen trilfunctie
    }
    call(`/api/remote/${code}/cmd`, { method: 'POST', body: JSON.stringify({ key }) }).catch((e) => {
      setError(e instanceof ApiError && e.message !== e.code ? e.message : 'Verbinding met het scherm verbroken.');
      setCode(null);
    });
  };

  if (!code) {
    return (
      <main className="page center-screen remote-page">
        <h1>Afstandsbediening</h1>
        <p className="muted" style={{ maxWidth: '40ch', textAlign: 'center' }}>
          Op de tv: Instellingen → "Telefoon als afstandsbediening". Vul de code van 6 cijfers in die daar staat.
        </p>
        <form onSubmit={(e) => { e.preventDefault(); if (input.length === 6) void connect(input); }} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
          <input className="pin-input together-code" inputMode="numeric" value={input} maxLength={6} autoFocus aria-label="Code" onChange={(e) => setInput(e.target.value.replace(/\D/g, ''))} />
          {error && <p className="error" role="alert">{error}</p>}
          <button className="btn btn-primary" disabled={input.length !== 6}>Koppelen</button>
        </form>
      </main>
    );
  }

  const B = ({ k, label, cls = '' }: { k: Key; label: string; cls?: string }) => (
    <button type="button" className={`rc-btn ${cls}`} aria-label={label} onClick={() => press(k)}>{rcIcon(k) ?? label}</button>
  );

  return (
    <main className="page remote-page">
      <div className="rc">
        <div className="rc-row">
          <B k="Escape" label="Terug" />
          <B k="home" label="Home" />
          <B k="search" label="Zoeken" />
        </div>
        <div className="rc-pad">
          <B k="ArrowUp" label="Omhoog" cls="up" />
          <B k="ArrowLeft" label="Links" cls="left" />
          <B k="Enter" label="OK" cls="ok" />
          <B k="ArrowRight" label="Rechts" cls="right" />
          <B k="ArrowDown" label="Omlaag" cls="down" />
        </div>
        <div className="rc-row">
          <B k="seek-back" label="10 seconden terug" />
          <B k="MediaPlayPause" label="Afspelen/pauze" cls="wide" />
          <B k="seek-forward" label="30 seconden vooruit" />
        </div>
        <div className="rc-row">
          <B k="ChannelUp" label="Zender omhoog" />
          <B k="info" label="Info" />
          <B k="ChannelDown" label="Zender omlaag" />
        </div>
        <button className="btn subtle" onClick={() => setCode(null)}>Ontkoppelen</button>
      </div>
    </main>
  );
}

function rcIcon(k: Key): string | null {
  switch (k) {
    case 'ArrowUp': return '▲';
    case 'ArrowDown': return '▼';
    case 'ArrowLeft': return '◀';
    case 'ArrowRight': return '▶';
    case 'Enter': return 'OK';
    case 'Escape': return '↩';
    case 'home': return '⌂';
    case 'search': return '⌕';
    case 'info': return 'i';
    case 'MediaPlayPause': return '⏯';
    case 'seek-back': return '−10';
    case 'seek-forward': return '+30';
    case 'ChannelUp': return 'CH+';
    case 'ChannelDown': return 'CH−';
    default: return null;
  }
}
